export const COUNT_OPEN_CHAT_CONVERSATIONS_REQUEST = 'COUNT_OPEN_CHAT_CONVERSATIONS_REQUEST';

export const countOpenChatConversationsRequest = () => ({
    type: COUNT_OPEN_CHAT_CONVERSATIONS_REQUEST,
});
